import { motion, AnimatePresence } from 'framer-motion'
import { MessageCircle, Facebook, Linkedin } from 'lucide-react'

const FloatingSocial = () => {
  const socialLinks = [
    {
      name: 'WhatsApp',
      url: 'https://wa.me/8801521721890',
      icon: MessageCircle,
      color: 'from-green-500 to-green-600',
      hoverColor: 'hover:from-green-600 hover:to-green-700'
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/profile.php?id=61583285977385',
      icon: Facebook,
      color: 'from-blue-600 to-blue-700',
      hoverColor: 'hover:from-blue-700 hover:to-blue-800'
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/111804312/admin/dashboard/',
      icon: Linkedin,
      color: 'from-blue-700 to-blue-900',
      hoverColor: 'hover:from-blue-800 hover:to-blue-950'
    }
  ]

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
      <AnimatePresence>
        {socialLinks.map((social, index) => (
          <motion.a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ delay: index * 0.1, type: 'spring', stiffness: 260, damping: 20 }}
            whileHover={{ scale: 1.1, rotate: 5 }}
            whileTap={{ scale: 0.9 }}
            className={`p-4 bg-gradient-to-r ${social.color} ${social.hoverColor} text-white rounded-full shadow-lg transition-all duration-300 group relative`}
            aria-label={social.name}
          >
            <social.icon size={24} />
            
            {/* Tooltip */}
            <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-1 bg-slate-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
              {social.name}
            </span>

            {/* Ping Animation */}
            <span className="absolute inset-0 rounded-full bg-white/20 animate-ping"></span>
          </motion.a>
        ))}
      </AnimatePresence>
    </div>
  )
}

export default FloatingSocial
